// extracted by mini-css-extract-plugin
module.exports = {"search-fade-in":"InsightsTopicFilterInsights_search-fade-in__uw_aj"};